<template>
  <div id="app" data-server-rendered="true">
    <router-view/>
  </div>
</template>

<script>
// import 'static/cdn/element-ui.css'
// import 'static/cdn/vue.js'
// import 'static/cdn/element-ui.js'
export default {

  name: 'App',
  mounted () {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 6000)

  }
}
</script>

<style>
#app {
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue